import tradeDataStore from "@/store/tradeDataStore";
import { ExecutionStrategy } from "@/lib/interfaces and Enums/InterfaceExecutionStrategy";
import { getFormattedStructureType } from "./structureTypeHelpers";

/**
 * Pure formatting function for structure type cell
 * Used by both valueFormatter (for copy/paste) and cellRenderer (for display)
 *
 * @param params - AG Grid cell params
 * @param tradeData - The trade data from Zustand store
 * @returns Formatted structure type string
 */
export function formatStructureTypeValue(
  params: any,
  tradeData: ExecutionStrategy[],
): string {
  if (!params.data) {
    return "";
  }

  const data = params.data as ExecutionStrategy;
  const { formattedText } = getFormattedStructureType(data, tradeData);

  return formattedText;
}

/**
 * AG Grid valueFormatter for copy/paste functionality
 * This ensures copied values match what's displayed by accessing Zustand store
 */
export function structureTypeValueFormatter(params: any): string {
  if (!params.data) {
    return "";
  }

  // Access Zustand store directly to get current trade data
  const currentTradeData = tradeDataStore.getState().tradeData;

  return formatStructureTypeValue(params, currentTradeData);
}
